const SNAPSOFT_ENDPOINT = 'https://4w2hpsdptd.execute-api.us-east-2.amazonaws.com/dev';

export function getRecommendationConnection({ proxyPath, directEnabled, endpoint, apiKey }) {
  const proxy = proxyPath?.trim();
  if (proxy) return { url: proxy, direct: false };
  if (directEnabled !== 'true' || !apiKey?.trim()) return null;
  return {
    url: `${(endpoint?.trim() || SNAPSOFT_ENDPOINT).replace(/\/+$/, '')}/recommendations`,
    direct: true,
    apiKey: apiKey.trim(),
  };
}
